import { useIsSignedIn } from "PFApp/hooks";
import { useEffect, useState } from "react";
import { Navigate } from "react-router";

export const MsTeamsRootPage = () => {
  const { isSignedIn } = useIsSignedIn();

  if (isSignedIn) {
    return <MsTeamsRedirect />;
  } else {
    return <Navigate to="/ms_teams/signin" replace />;
  }
};

const MsTeamsRedirect = () => {
  const [redirectPath, setRedirectPath] = useState<string | null>(null);

  useEffect(() => {
    if (window.microsoftTeams) {
      window.microsoftTeams.getContext((context) => {
        const lastVisitedPath = window.storage.getItem("ms_teams_last_visited_path");
        window.storage.removeItem("ms_teams_last_visited_path");
        setRedirectPath(context.subEntityId || lastVisitedPath || "/");
      });
    } else {
      setRedirectPath("/");
    }
  }, []);

  return redirectPath ? <Navigate to={redirectPath} replace /> : null;
};
